const openUrl = (url) => {
  if (typeof window !== 'undefined') {
    window.open(url);
  }
};

const separateNames = (names) => {
  const divNames = names.trim().split(' ');
  const name = divNames.shift();
  let lastName = '';
  if (divNames.length > 0) {
    lastName = divNames.join(' ');
  }
  return {
    name,
    lastName,
  };
};

const concatenateArray = (arr, maxLength) => {
  if (arr.length === 0) {
    return '';
  } else if (arr.length === 1) {
    return truncateString(arr[0], maxLength);
  } else {
    const allButLast = arr.slice(0, -1).join(', ');
    const last = arr[arr.length - 1];
    return truncateString(`${allButLast} y ${last}`, maxLength);
  }
};

const truncateString = (str, maxLength) => {
  if (typeof maxLength === 'undefined') {
    return str;
  }

  if (str.length > maxLength) {
    return str.slice(0, maxLength - 3) + '...';
  } else {
    return str;
  }
};

export { openUrl, separateNames, concatenateArray };
